import React, { useEffect, useState } from "react";
import {
  CheckBoxBanner,
  ErrorMessage,
  Separator,
  SuccessMessage,
} from "src/components";
import styles from "./styles.module.scss";
import { UIButton, UIText } from "src/components/uIKit";
import { useAppDispatch, useAppSelector } from "src/hooks/useRedux";
import { images } from "src/assets/images/images";
import {
  API_RESULT,
  CHANNELS,
  ROUTES,
  TEXT_TAGS,
  URL_SOURCE_TYPE,
} from "src/utils/enums";
import { leadsTransferringPopupHeight } from "src/utils/utils";
import { resetPopupInfo } from "src/redux/slices/popupSlice/popupSlice";
import { useLocation, useNavigate } from "react-router-dom";
import { sendLeadOrSms, startOnboardingEnsure } from "src/redux/slices/appSlice/AppApi";
import RadioBtnBanner from "src/components/radioBtnBanner";
import { useIsMobile } from "src/hooks/useIsMobile";
import { useLogAnalytics } from "src/hooks/useLogAnalytics";
interface ILeadsTransferringPopupProps {
  mobileImg?: string;
  hideCloseBtn?: boolean;
  updateFoucse: () => void;
}

const LeadsTransferringPopup = ({
  mobileImg,
  hideCloseBtn,
  updateFoucse,
}: ILeadsTransferringPopupProps) => {
  const {
    strings,
    personalId,
    travelPolicyNumber,
    businessUnit,
    sendLeadOrSmsResStatus,
    agentId,
    campaignId,
    campaignName,
    fXEligibilityData,
  } = useAppSelector((state) => state.app);
  const isMobile = useIsMobile();
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  useLogAnalytics({ ensure_agent_options: true });

  const [selectedLeadOptionIndex, setSelectedLeadOptionIndex] = useState<
    number | null
  >(null);
  const [buttonDisabled, setButtonDisabled] = useState(false);
  const [showSuccessMessage, setShowSuccessMessage] = useState(false);
  const [showLoading, setShowLoading] = useState(false);
  const [showError, setShowError] = useState(false);
  const [successPopupTitle, setSuccessPopupTitle] = useState("");
  const [successPopupSubTitle, setSuccessPopupSubTitle] = useState("");
  const [successPopupBody, setSuccessPopupBody] = useState("");

  // Determine if the SMS option should be enabled.
  // 1. If 'enableSMS' exists and is true  -> true
  // 2. If 'enableSMS' does NOT exist      -> true
  // 3. If 'enableSMS' exists and is false -> false
  const enableSMS = fXEligibilityData?.enableSms === undefined ? true : fXEligibilityData.enableSms;
  const enableOnboarding = fXEligibilityData?.enableImmediateOnboard === undefined ? true : fXEligibilityData.enableImmediateOnboard;
  const leadsOptions = [
    {
      index: 1,
      title: strings.t_leads_transferring_title1,
      subTitle: strings.t_leads_transferring_sub_title1,
      enabled: enableOnboarding,
    },
    {
      index: 2,
      title: strings.t_leads_transferring_title2,
      subTitle: strings.t_leads_transferring_sub_title2,
      enabled: fXEligibilityData?.leadButton,
    },
    {
      index: 3,
      title: strings.t_leads_transferring_title3,
      subTitle: strings.t_leads_transferring_sub_title3,
      enabled: enableSMS,
    },
  ];

  useEffect(() => {
    setButtonDisabled(selectedLeadOptionIndex === null);
  }, [selectedLeadOptionIndex]);

  const handleCheckboxChange = (index: number) => {
    setSelectedLeadOptionIndex(index);
  };
  useEffect(() => {
    if (sendLeadOrSmsResStatus === API_RESULT.SUCCEEDED) {
      setShowSuccessMessage(true);
    } else if (sendLeadOrSmsResStatus === API_RESULT.FAILED) {
      setShowLoading(false);
      setShowError(true);
    } else if (sendLeadOrSmsResStatus === API_RESULT.LOADING) {
      setShowLoading(true);
    }
  }, [sendLeadOrSmsResStatus]);

  const onSubmit = () => {
    switch (selectedLeadOptionIndex) {
      case 1:
        closePopup();
        const data = {
          feChannel: CHANNELS.ENSURE,
          feBU: businessUnit,
          fePersonalId: personalId,
          feCustPolicyId: travelPolicyNumber,
        };
        dispatch(startOnboardingEnsure(data));
        const currentSource = location.pathname.split("/")[1];
        const isEnsureOrPfsRep =
          currentSource === URL_SOURCE_TYPE.ENSURE ||
          currentSource === URL_SOURCE_TYPE.PFS_REP;
        if (isEnsureOrPfsRep) {
          navigate(`/${currentSource}/${ROUTES.PC_PLUS_SCREEN}`);
        } else {
          navigate(`/${currentSource}/${ROUTES.UPDATE_CONTACT_DETAILS}`);
        }
        break;
      case 2:

        // console.log("Lead clicked");
        setSuccessPopupTitle(strings.t_leads_transferring_title2);
        setSuccessPopupSubTitle(strings.t_leads_transferring_success_message);
        setSuccessPopupBody(strings.t_leads_transferring_success_message_sub_title);
        callSendLeadOrSms(CHANNELS.PFS_REP);
        break;
      case 3:
        // console.log("SMS clicked");
        setSuccessPopupTitle(strings.t_leads_transferring_title3);
        setSuccessPopupSubTitle(strings.t_sms_transferring_success_message);
        setSuccessPopupBody(strings.t_sms_transferring_success_message_sub_title);
        callSendLeadOrSms(CHANNELS.SMS);
        break;

      default:
        break;
    }
  };
  const callSendLeadOrSms = (channel: number) => {
    setShowLoading(true);
    const requestProperties = {
      feChannel: channel,
      feBU: businessUnit,
      feCustPersId: personalId,
      feCustTravelPolicyNumber: travelPolicyNumber,
      feAgentId: agentId ?? "",
      feCampaignId: channel === CHANNELS.CAMPAIGN ? campaignId : null,
      feCampaignName: channel === CHANNELS.CAMPAIGN ? campaignName : null,
    };
    dispatch(sendLeadOrSms(requestProperties));
  };
  const closePopup = () => {
    dispatch(resetPopupInfo());
  };
  useEffect(() => {
    updateFoucse();
  }, [showSuccessMessage]);
  
  const reloadPage = () => {
    // window.location.reload();
    setShowSuccessMessage(false);
    setSelectedLeadOptionIndex(null);
    setShowLoading(false);
    // setButtonDisabled(false);
  };
  return (
    <div
      className={styles.container}
      style={{ height: isMobile ? leadsTransferringPopupHeight : "auto" }}
    >
      <div className={styles.card}>
        {!isMobile && (
          <div>
            <img src={images.image1} alt="" className={styles.agentImage} />
          </div>
        )}

        <div className={styles.infoPart}>
          <div className={styles.popupHeader}>
            <UIText
              isAriaHidden={showSuccessMessage}
              tabIndex={0}
              text={showSuccessMessage ? successPopupTitle : strings.t_leads_transferring_title}
              tag={TEXT_TAGS.H1}
              size={28}
              weight={500}
              style={styles.cardTitle}
            />

            {/* {!hideCloseBtn && (
              <div className={styles.closeWrapper} onClick={closePopup}>
                <img alt="close" src={images.close} className={styles.close} />
              </div>
            )} */}
            {showSuccessMessage && (
              <div className={styles.closeWrapper} onClick={reloadPage}>
                <img alt="close" src={images.close} className={styles.close} />
              </div>
            )}
          </div>

          {!showSuccessMessage && (
            <Separator
              separatorWrapper={styles.separatorWrapper}
              className={styles.separator}
            />
          )}
          {isMobile && (
            <div className={styles.mobileImgWrapper}>
              <img alt="" src={mobileImg} className={styles.mobileImg} />
            </div>
          )}
          {showSuccessMessage ? (
            <SuccessMessage
              isHidden={!showSuccessMessage}
              title={successPopupSubTitle}
              subtitle={successPopupBody}
              image={images.success}
              imageAlt="Success"
            />
          ) : (
            <div
              className={`${showSuccessMessage
                ? styles.visibilityHidden
                : styles.subtitleWrapper
                }`}
            >
              <UIText
                tabIndex={0}
                isAriaHidden={showSuccessMessage}
                text={strings.t_leads_transferring_sub_title}
                size={18}
                weight={400}
                style={styles.cardSubTitle}
              />
              <br />
              <br />
              <br />

              <UIText
                text={strings.t_leads_transferring_what_next}
                tag={TEXT_TAGS.H2}
                size={18}
                weight={500}
              />

              <fieldset>
                {leadsOptions.map(
                  (option) =>
                    option.enabled && (
                      <RadioBtnBanner
                        isHidden={showSuccessMessage}
                        name={`LeadsTransferring`}
                        title={option.title}
                        key={`LeadsTransferring-RadioBtnBanner-${option.index}`}
                        subTitle={option.subTitle}
                        index={option.index}
                        isChecked={selectedLeadOptionIndex === option.index}
                        onCheckboxChange={handleCheckboxChange}
                      />
                    )
                )}
              </fieldset>
              <br />
              {showError && (
                <ErrorMessage
                  message={strings.t_leads_transferring_error_message}
                />
              )}
              <div className={styles.buttonWrapepr}>

                <UIButton
                  isHidden={showSuccessMessage}
                  title={strings.t_active_credit_next}
                  onSubmit={onSubmit}
                  disabled={buttonDisabled || showLoading}
                  isLoading={showLoading}
                />
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default LeadsTransferringPopup;
